<template>
	<Icon
		:icon="icon"
		:width="width == 0 ? null : width"
		:height="height == 0 ? null : height"
		:horizontal-flip="horizontalFlip"
		:vertical-flip="verticalFlip"
		:rotate="rotate"
		:color="color"
	/>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { Icon } from "@iconify/vue";

export default defineComponent({
	name: "BaseIcon",
	components: { Icon },
	props: {
		icon: {
			type: String,
			required: true,
		},
		width: {
			type: Number,
			default: 0,
		},
		height: {
			type: Number,
			default: 0,
		},
		horizontalFlip: {
			type: Boolean,
			default: false,
		},
		verticalFlip: {
			type: Boolean,
			default: false,
		},
		rotate: {
			type: [Number, String],
			default: 0,
		},
		color: {
			type: String,
			default: "#1E2328",
		},
	},
});
</script>
